import { FC, memo, useEffect, } from "react";
import { SearchBarProps } from "./types";
import {
  ActionButton,
  ActionButtonsWrapper,
  CartText,
  HeaderStyled,
  SelectVehicleHeader,
  SelectVehicleText,
} from "./styled";
// import { HeaderStyled, LogoWrapper } from "./styled";
import { DynamicSelector } from "..";
import { useGlobalContext } from "../../context";
import { CloseIcon } from "../../assets/closeIcon";
import { SptLocalStorageVariables } from "../../common/constants/localStorage";
import { CartIcon } from "../../assets/cartIcon";
import { getCartRequest } from "../../api/autoParts";
// import { isValidImage } from "../../common/helpers";

const SearchBar: FC<SearchBarProps> = ({
  // setTab,
  searchError,
  handleShowFilters,
  openApp,
  hideHeader,
  // storeLogo,
}) => {
  const { state, dispatch } = useGlobalContext();
  const { year, make, model, cartInfo, selectorModalConfig, addedToCart } = state;

  // const [cartInfo, setCartInfo] = useState<any>({});

  const noVehicle = !year.label || !make.label || !model.label;
  const refreshOnClose = selectorModalConfig?.refresh_page_after_selector_closed;
  const addToCart = selectorModalConfig?.add_to_cart_enabled;

  const currentVehicle = noVehicle
    ? "Select Vehicle"
    : `${year.label} ${make.label} ${model.label}`;

  const handleClose = () => {
    // add refresh
    
    let elem = document.getElementById("spt-react-app");
    if (elem) {
      elem.style.display = "none";
    }
    if(addedToCart && refreshOnClose) {
      
      dispatch({ type: "setAddedToCart", payload: false });
      window.location.reload();
    }

    const keysToRemove = [
      SptLocalStorageVariables.SPT_FILTERS,
      SptLocalStorageVariables.SPT_PRODUCTS,
      SptLocalStorageVariables.SPT_SELECTED_FILTERS,
      SptLocalStorageVariables.SPT_SELECTORS,
    ];

    keysToRemove.forEach((k) => localStorage.removeItem(k));
  };

  const openCart = () => {
    window.location.href = '/cart';
  }

  const getCartInfo = async () => {
    const data = await getCartRequest();
    dispatch({ type: "setCartInfo", payload: data });
  };

  useEffect(() => {
    // @ts-ignore
    console.log(window.Shopify, "shopify routes");
    getCartInfo();
  }, []);

  // const [isValidLogo, setIsValidLogo] = useState(false);

  // const testImage = async () => {
  //   const isValid = await isValidImage(storeLogo);
  //   setIsValidLogo(isValid);
  // };
  // useEffect(() => {
  //   testImage();
  // }, []);
  return (
    <HeaderStyled className="search-bar-header-class">
      {/* <div>
        <LogoWrapper>
          {isValidLogo && storeLogo && <img src={storeLogo} alt="logo" width={"100px"} height={"100px"} />}
        </LogoWrapper>
      </div> */}
      {!hideHeader && (
        <SelectVehicleHeader>
          <SelectVehicleText className="search-bar-heading-color">{currentVehicle}</SelectVehicleText>
          <ActionButtonsWrapper>
            {addToCart && <ActionButton onClick={openCart}>
              <CartIcon />
              {cartInfo?.item_count > 0 && <CartText>{cartInfo?.item_count}</CartText>}
            </ActionButton>}
            <ActionButton onClick={handleClose}>
              <CloseIcon />
            </ActionButton>
          </ActionButtonsWrapper>
        </SelectVehicleHeader>
      )}
      <DynamicSelector
        // setTab={setTab}
        searchError={searchError}
        handleShowFilters={handleShowFilters}
        openApp={openApp}
      />
      {/* <div>
        <LogoWrapper />
      </div> */}
    </HeaderStyled>
  );
};

export default memo(SearchBar);
